var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 101,
    viewBox: "0 0 273 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 272,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_60591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.352 46.0641C181.144 46.0641 180.081 46.3499 179.175 46.9332C178.448 47.3954 177.867 48.0119 177.409 48.7822L177.387 46.4283H174.198V61.6575H177.519V53.1409C177.519 52.3155 177.676 51.5877 178 50.9495C178.313 50.3111 178.762 49.8169 179.344 49.4646C179.926 49.1125 180.595 48.9361 181.378 48.9361C182.071 48.9361 182.676 49.0795 183.168 49.3657C183.672 49.6518 184.04 50.0688 184.297 50.5971C184.554 51.1363 184.677 51.7761 184.677 52.5134V61.6575H187.998V52.0501C188.021 50.8725 187.775 49.8384 187.316 48.936C186.873 48.0618 186.186 47.3294 185.337 46.8237C184.487 46.3174 183.492 46.0641 182.352 46.0641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.097 40.0332V43.3888H170.453V40.0332H167.097ZM167.097 46.4275V61.6568H170.419V46.4275H167.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.029 40V61.6574H163.351V40H160.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.569 42.6191V45.2046C150.569 45.6118 150.468 45.9211 150.267 46.1192C150.066 46.3173 149.753 46.4281 149.328 46.4281H147.728V49.1679H150.512V57.3657C150.512 58.2131 150.691 58.9733 151.038 59.6226C151.384 60.2719 151.888 60.777 152.536 61.1291C153.185 61.4813 153.958 61.6695 154.842 61.6695H157.334V58.8188H155.455C154.974 58.8188 154.584 58.6541 154.27 58.3239C153.968 57.9937 153.824 57.5537 153.824 57.0035V49.1779H157.425V46.4281H153.824V42.6192L150.569 42.6191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.071 46.0635C137.528 46.0635 136.152 46.4047 134.933 47.087C133.734 47.7515 132.747 48.731 132.082 49.9159C131.4 51.1265 131.064 52.502 131.064 54.0317C131.064 55.5725 131.4 56.9369 132.082 58.1475C132.732 59.336 133.714 60.3173 134.911 60.9764C136.13 61.6588 137.505 62 139.049 62C140.57 62 141.935 61.6588 143.143 60.9764C144.328 60.3102 145.301 59.3301 145.949 58.1475C146.62 56.937 146.955 55.5614 146.955 54.0317C146.955 52.491 146.62 51.1266 145.949 49.9159C145.278 48.7054 144.35 47.7692 143.143 47.087C141.946 46.4047 140.592 46.0635 139.071 46.0635ZM139.049 49.0014C139.91 49.0014 140.682 49.2116 141.364 49.6408C142.035 50.07 142.56 50.6642 142.929 51.4127C143.298 52.172 143.479 53.0402 143.479 54.0417C143.49 55.0322 143.31 55.9015 142.929 56.6608C142.56 57.4202 142.035 58.0145 141.364 58.4327C140.693 58.8619 139.911 59.0721 139.039 59.0721C138.155 59.0721 137.372 58.8619 136.679 58.4327C135.997 58.0035 135.46 57.4093 135.08 56.6608C134.7 55.9015 134.508 55.0322 134.508 54.0417C134.508 53.0512 134.7 52.172 135.08 51.4127C135.46 50.6533 135.997 50.059 136.679 49.6408C137.361 49.2116 138.154 49.0014 139.049 49.0014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.485 40.8038L118.338 50.4112V40.8355H114.96V61.6577H118.338V51.5673L127.52 61.6577H131.869L122.084 50.8843L131.69 40.8037L127.485 40.8038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.171 61.6581H85V40.8359H106.171L95.367 51.0925L106.171 61.6581Z",
    fill: "url(#paint0_radial_1909_60591)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1909_60591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.464 41.6885) scale(24.2408 23.8546)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#E44857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#C711E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F52FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_60591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 22,
    fill: "white",
    transform: "translate(85 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/Kotlin.29481a18da3719db5689ce63c81fb0fc.svg";
export { ForwardRef as ReactComponent };